import { Typography, Box, CircularProgress, Tabs, Tab } from '@mui/material'
import * as React from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useTokenClaims } from '../security/useTokenClaims'
import { getQcInspectionRequests } from '../services/inspectionsService'
import { QCBacklogList } from '../components/InspectionBacklog/WorkItemHierarchy/QCBacklogList'
import { RequestWorkItem } from '../types/Work/Request'
import { RequestCard } from '../components/InspectionBacklog/RequestCard'
import { QCProvider } from '../components/InspectionBacklog/QCContext'
import dayjs from 'dayjs'

function a11yProps(index: number) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	}
}
const InspectionDetailPage = () => {
	const params = useParams()
	const [loading, setLoading] = useState(false)
	const { id } = useTokenClaims()
	const [pendingRequestsWis, setPendingRequestsWis] = useState<RequestWorkItem[]>()
	const [historyRequestsWis, setHistoryRequestsWis] = useState<RequestWorkItem[]>()
	const [pendingTab, setPendingTab] = useState(true)
	const [value, setValue] = React.useState(0)
	const location = useLocation()
	const { requestId, fromNotification, key } =
		(location.state as {
			requestId: string
			fromNotification: boolean
			key: number
		}) || {}

	useEffect(() => {
		;(async () => {
			setLoading(true)
			await loadRequests()
			setLoading(false)
		})()
	}, [params.id])

	// Add effect to switch to pending tab when coming from notification
	useEffect(() => {
		if (fromNotification) {
			setValue(0) // Switch to pending tab
			setPendingTab(true)
		}
	}, [fromNotification, key])

	const loadRequests = async () => {
		const requestsData = await getQcInspectionRequests(params.id ? parseInt(params.id) : id)
		setPendingRequestsWis(requestsData.filter((r) => r.request.status === 'Pending'))
		setHistoryRequestsWis(requestsData.filter((r) => r.request.status !== 'Pending'))
	}

	return (
		<>
			{loading ? (
				<CircularProgress color='success' />
			) : (
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						height: 'calc(100vh - 64px)',
						overflow: 'clip',
					}}
				>
					<div style={{ display: 'flex', justifyContent: 'space-between' }}>
						<Typography sx={{ fontSize: '1.5rem', paddingLeft: '1rem', paddingTop: '.5rem' }}>
							Inspection Backlog
						</Typography>
					</div>
					<Box sx={{ width: '100%' }}>
						<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
							<Tabs value={value} onChange={(_, newValue) => setValue(newValue)}>
								<Tab
									color='#ff000'
									label='Pending Inspections'
									sx={(theme) => ({
										color: theme.palette.info.main,
										'&:selected': theme.palette.info.main,
									})}
									{...a11yProps(0)}
									onClick={() => setPendingTab(true)}
								/>
								<Tab
									color='info'
									label='History'
									sx={(theme) => ({
										color: theme.palette.info.main,
										'&:selected': theme.palette.info.main,
									})}
									{...a11yProps(1)}
									onClick={() => setPendingTab(false)}
								/>
							</Tabs>
						</Box>
					</Box>
					<Box sx={{ display: 'flex', overflowY: 'auto', mt: 4, flexDirection: 'column', gap: 2 }}>
						{historyRequestsWis &&
							!pendingTab &&
							(historyRequestsWis.length === 0 ? (
								<Typography textAlign={'center'}>No Previous Requests Found</Typography>
							) : (
								// sort by inspectedAt descending
								historyRequestsWis
									.sort((a, b) => dayjs(b.request.inspectedAt).diff(dayjs(a.request.inspectedAt)))
									.map((item) => (
										<QCProvider key={item.request.id} hierarchy={item.hierarchy}>
											<RequestCard request={item.request}>
												<QCBacklogList hierarchy={item.hierarchy} />
											</RequestCard>
										</QCProvider>
									))
							))}

						{pendingRequestsWis &&
							pendingTab &&
							(pendingRequestsWis.length === 0 ? (
								<Typography textAlign={'center'}>No Pending Requests Found</Typography>
							) : (
								// Sort by requestedAt descending
								pendingRequestsWis
									.sort((a, b) => dayjs(b.request.requestedAt).diff(dayjs(a.request.requestedAt)))
									.map((item) => (
										<QCProvider key={item.request.id} hierarchy={item.hierarchy}>
											<RequestCard
												request={item.request}
												loadParentData={loadRequests}
												expandedFromNotification={item.request.id === parseInt(requestId)}
											>
												<QCBacklogList hierarchy={item.hierarchy} />
											</RequestCard>
										</QCProvider>
									))
							))}
					</Box>
				</Box>
			)}
		</>
	)
}

export default InspectionDetailPage
